/**
 * A single picture, alone on its own page.
 *
 * Everything this kind is: how it is made, how it is read back, what it looks
 * like on the page, and how it is edited. Nothing outside this folder needs to
 * know the kind exists.
 */

import { readBoolean, readString } from '@/domain/json'
import { type ImagePageSection } from '@/domain/section'
import ImagePageBlock from '@/sections/imagePage/ImagePageBlock.vue'
import ImagePageInspector from '@/sections/imagePage/ImagePageInspector.vue'
import type { SectionDefinition } from '@/sections/types'

export const imagePageSection: SectionDefinition<'imagePage', ImagePageSection> = {
  kind: 'imagePage',
  band: 'structure',

  icon: ['M3.5 1.5h9v13h-9z', 'M3.5 9.5 5.7 7.3l1.8 1.8 1.5-1.5 2.5 2.5', 'M9.7 5a.5.5 0 1 0 0-.1'],

  create: (id, title) => ({
    id,
    kind: 'imagePage',
    title,
    image: '',
    spread: false,
  }),

  read: ({ id, title, stored }) => ({
    id,
    kind: 'imagePage',
    title,
    image: readString(stored, 'image'),
    spread: readBoolean(stored, 'spread'),
  }),

  block: ImagePageBlock,
  inspector: ImagePageInspector,
}
